module.exports = __webpack_public_path__ + "media/פה.eb780965.mp3";